import React, {ReactElement} from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import UniversalInput from '../../../../../lib/wrappers/UniversalInput';

// Constants

import { DROPDOWN_OPTIONS } from '../../../../../constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '../../../../../constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '../../../../../constants/inputs/validationTypes';

// Types

import { SsapData } from '../../../SsapTypes';

interface IncomeDataUsageAttestation {
    actions: {
        onFieldChange_finConsent: Function,
    },
    data: SsapData,
    exchangeName: string,
    formName: string,
    isFinancialFlow: boolean
}


const IncomeDataUsageAttestation = (props: IncomeDataUsageAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_finConsent
        },
        data,
        data: {
            agreeToUseIncomeData
        },
        exchangeName,
        formName,
        isFinancialFlow
    } = props;

    const getLegendProps = () => {
        switch(true) {
            case isFinancialFlow:
                return {
                    legendText: 'ssap.input.legend.agree_to_use_income_details',
                    dataInstructions: 'instructional_text.sign_submit_agreement',
                    legendTextReplacements: {
                        exchangeName
                    },
                    replacements: {
                        exchangeName
                    }
                };
            default:
                return {
                    legendText: 'ssap.input.legend.consent_agreement',
                    legendTextReplacements: {
                        question: (
                            <div className = 'para-heading required-true' >
                                <FormattedMessage id = 'ssap.sign_and_review.to_save_time_question' />
                            </div>
                        ),
                        warning: (
                            <div className = 'para-heading-supporting-txt' >
                                <FormattedMessage
                                    id = 'ssap.sign_and_review.to_save_time_warning'
                                    values={ {
                                        exchangeName
                                    } }
                                />
                            </div>
                        )
                    }
                };
        }
    };

    const getLabelProps = () => {
        switch(true) {
            case isFinancialFlow:
                return {
                    showRequiredIcon: true
                };
            default:
                return {
                    labelClass: [ 'required-false' ],
                    showRequiredIcon: false
                };
        }
    };

    return (
        <UniversalInput
            legend = { getLegendProps() }
            label = { getLabelProps() }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.RADIO_BUTTONS,
                name: 'agreeToUseIncomeData',
                value: agreeToUseIncomeData,
                options: DROPDOWN_OPTIONS.AGREE_DISAGREE,
                validationType: VALIDATION_TYPES.CHOSEN,
                currentData: data,
                fields: [ ]
            } }
            inputActions = { {
                onFieldChange: onFieldChange_finConsent
            } }
            errorClasses = { [ 'margin-l-0' ] }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default IncomeDataUsageAttestation;